import { Controller } from "@hotwired/stimulus"
import dr from "defang-refang"

export default class extends Controller {
  static targets = ["scope", "type", "value"]

  normalize() {
    this.valueTarget.value = dr.refang(this.valueTarget.value.trim())
  }

  preserveValue(event) {
    if (event.detail.url.searchParams.has("value")) return

    const value = this.valueTarget.value.trim()
    if (value) event.detail.url.searchParams.set("value", value)
  }
}
